var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.004,
    viewBox: "0 0 20 20.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "house-laptop",
    d: "M19.167,15.641V12.082a3.756,3.756,0,0,0-3.75-3.75H9.583a3.756,3.756,0,0,0-3.75,3.75v3.558A2.5,2.5,0,0,0,7.5,20h10a2.5,2.5,0,0,0,1.667-4.358ZM7.5,12.082A2.084,2.084,0,0,1,9.583,10h5.833A2.084,2.084,0,0,1,17.5,12.082V15H15.342a1.638,1.638,0,0,0-1.175.492l-.342.342H11.183l-.342-.342A1.688,1.688,0,0,0,9.667,15H7.508V12.082Zm10,6.25H7.5a.833.833,0,1,1,0-1.667H9.658l.342.342a1.688,1.688,0,0,0,1.175.492h2.642a1.638,1.638,0,0,0,1.175-.492l.342-.342h2.158a.833.833,0,0,1,0,1.667Zm-14.167-5a1.672,1.672,0,0,1-1.667-1.667V6.774a2.479,2.479,0,0,1,.958-1.967L5.958,2.2a2.5,2.5,0,0,1,3.083,0l3.333,2.608a2.485,2.485,0,0,1,.858,1.258.833.833,0,1,0,1.6-.467,4.143,4.143,0,0,0-1.425-2.108l-.067-.05V.832a.833.833,0,1,0-1.667,0v1.3l-1.6-1.25a4.167,4.167,0,0,0-5.142,0L1.6,3.491A4.137,4.137,0,0,0,0,6.774v4.892A3.332,3.332,0,0,0,3.333,15a.833.833,0,0,0,0-1.667Zm9.992-9.9Z",
    transform: "translate(0 0.005)",
    fill: "#072430",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseLaptop);
export default __webpack_public_path__ + "static/media/house-laptop.97ed09ce028236b90a89f8c341efa8b0.svg";
export { ForwardRef as ReactComponent };